/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Button } from 'antd'
import Typography from 'antd/es/typography/Typography';
import { isEmpty } from '../../../utils/helpers';
import { DataGrid, GridFooterContainer } from '@mui/x-data-grid';
import { CustomNoRowsOverlay } from '../common';
import { Pagination } from '@mui/material';
import { emptyElement, StatusRender } from './DataTableContent';
import DataTableActionsRender from './DataTableActions';
import moment from 'moment-timezone';


function DataGridTable({ tableStructure = [], paginationMode = "server", tableActions = [], loading = false, setLoading = () => { }, totalCount, data, pagination = false, handleChangePagination }) {
    const { Text } = Typography;

    const [customColumns, setCustomColumns] = useState([]);
    const [isTableLoading, setTableLoading] = useState(loading);

    useEffect(() => {
        setTableLoading(loading);
    }, [loading])

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
            setTableLoading(false);
        }, 600);
    }, [data])

    useEffect(() => {
        const customizeColumns = tableStructure?.map((item, itemIndex) => {
            const key = item?.key;
            const flex = item?.flex || 1;

            if (key === "actions") return {
                ...item, flex: flex, title: (tableActions.length !== 0 ? item?.title : ""),
                renderCell: (val) => <DataTableActionsRender tableActions={tableActions} val={val} />
            };

            if (key === "status" || key === "Status") {
                return {
                    ...item, flex: flex, renderCell: (val) => <StatusRender rowValue={val?.row} keyValue={key} />
                }
            }

            if (key === "created_at" || key === "updated_at") return {
                ...item,
                flex: flex,
                renderCell: (val) => {
                    const formatDate = moment(val?.row[key]).tz("America/Los_Angeles").format("DD-MM-YYYY HH:mm [PST]")
                    return (<span className='text-[13px] tracking-[0.2px]'>{formatDate}</span>)
                }
            }

            if (item?.renderCell) {
                const flex = item?.flex || 1;
                return { ...item, flex: flex }
            }

            return {
                ...item,
                flex: flex,
                renderCell: (val) =>
                    isEmpty(val?.row[key]) ?
                        emptyElement
                        :
                        <span className='text-[13px] tracking-[0.2px]'>{val?.row[key]}</span>
            }
        });
        setCustomColumns(customizeColumns);
    }, [tableStructure]);

    return (
        <DataGrid
            components={{
                NoRowsOverlay: CustomNoRowsOverlay,
                noResultsOverlay: CustomNoRowsOverlay,
            }}
            loading={isTableLoading}
            disableColumnMenu={true}
            rowCount={40}
            paginationMode={paginationMode}
            page={pagination?.page}
            paginationModel={pagination}
            disableRowSelectionOnClick
            rowHeight={45}
            columns={customColumns}
            className='!shadow-none !rounded-xl !border !border-slate-200 theme-datatable'
            classes={{
                columnHeader: "!uppercase !text-xs !bg-slate-50"
            }}
            rows={data}
            slots={{
                footer: () => (
                    <CustomFooter
                        pagination={pagination}
                        rowCount={totalCount}
                        labelDisplayedRows={({ from, to, count }) => {
                            if (count === 0) return <Text className="text-xs text-slate-500 space-x-1">Showing <span className="text-black">{0}</span><span>-</span><span className="text-black">{0}</span> result</Text>;
                            if (from === to) return <Text className="text-xs text-slate-500 space-x-1">Showing <span className="text-black">{from}</span><span>-</span><span className="text-black">{to}</span> result</Text>
                            return <Text className="text-xs text-slate-500 space-x-1">Showing <span className="text-black">{from}</span><span>-</span><span className="text-black">{to}</span> of <span className="text-black">{count}</span> results</Text>;
                        }}
                        onPageChange={(pageNumber) => {
                            handleChangePagination({ page: pageNumber, pageSize: pagination.pageSize })
                        }}
                    />
                ),
            }}
        />
    )
}


const CustomFooter = ({
    pagination,
    rowCount,
    labelDisplayedRows,
    onPageChange,
}) => {
    const { page, pageSize } = pagination;

    const from = page * pageSize + 1;
    const to = Math.min((page + 1) * pageSize, rowCount);
    const pageCount = Math.ceil(rowCount / pageSize);

    return (
        <GridFooterContainer
            className="flex justify-between items-center p-3"
        >
            <span className="text-sm !font-medium !text-slate-400">
                {labelDisplayedRows({ from, to, count: rowCount })}
            </span>
            <Pagination
                count={pageCount}
                page={page + 1}
                onChange={(_, value) => onPageChange(value - 1)}
                size="small"
                shape="rounded"
                siblingCount={1}
                boundaryCount={1}
                renderItem={(item) => {
                    const OutlinedButtonClass = '!bg-white !border !border-slate-400 !text-slate-400 flex items-center justify-center !text-xs !font-medium';
                    const isActive = item?.selected;
                    if (item.type === "previous") {
                        return <Button variant='outlined' size='small' disabled={item?.disabled} onClick={item?.onClick} className={OutlinedButtonClass}>Previous</Button>
                    }
                    if (item.type === "next") {
                        return <Button variant='outlined' size='small' disabled={item?.disabled} onClick={item?.onClick} className={OutlinedButtonClass}>Next</Button>
                    }
                    if (item?.page) {
                        return <Button variant={isActive ? "text" : "contained"} type={isActive ? 'primary' : "text"} size='small' disabled={item?.disabled} onClick={item?.onClick}>{item?.page}</Button>
                    }
                    return <Button type='text' disabled={true} size='small' className="text-xs !font-medium !text-slate-400">....</Button>
                }}
            />
        </GridFooterContainer>
    );
};

export default DataGridTable;
